import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { SyncFormDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import {
  ACTION_GET_FORM_DRAFT_DATA,
  DOMAIN_FORM_SUBMISSIONS,
  roleGuard,
} from "@api";

export const ACTION_SYNC_FORM = "SYNC_FORM";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type SyncFormRequest = {
  id: string;
  syncForm: SyncFormDto;
};

const syncForm = async (req: SyncFormRequest): Promise<void> => {
  await formsApi.formsControllerSyncForm(req.id, req.syncForm);
};

export const useSyncForm = (
  user: UserProfileDto | null,
  id: string,
): {
  syncForm: UseMutateFunction<void, unknown, SyncFormRequest, unknown>;
  syncFormAsync: (req: SyncFormRequest) => Promise<void>;
  syncFormEnabled: boolean;
  isSuccessSyncForm: boolean;
  isPendingSyncForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS, ACTION_SYNC_FORM, id],
    mutationFn: enabled ? syncForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FORM_SUBMISSIONS, ACTION_GET_FORM_DRAFT_DATA, id],
      });
    },
  });

  return {
    syncForm: mutate,
    syncFormAsync: mutateAsync,
    syncFormEnabled: enabled,
    isSuccessSyncForm: isSuccess,
    isPendingSyncForm: isPending,
  };
};
